import React    from 'react'
import Loadable from 'react-loadable'

const LoadableColorSlider = Loadable({
  loader: () => import('./ColorSlider'),
  loading: () => <div>Loading...</div>,
})

export const ColorSlider = (props) => <LoadableColorSlider {...props} />
